import ResourceAuthors from "./ResourceAuthors";

export default ResourceAuthors;
